"use-strict";

import 'jquery';
import '../assets/plugins/jquery.mask/jquery.mask.min';
export class Form {

    contactForm = $("#contact-form");

    processing = false;

    constructor() {
        this.init();
    }

    serializeForm(form) {
        let newform = {};
        form.forEach(element => {
            newform[element.name] = element.value;
        });
        return newform;
    }

    sendForm(form) {
        if (this.processing || form === null || form === undefined) {
            return;
        }

        this.processing = true;

        $.post({
            url: '/contact',
            data: form,
            beforeSend: () => {
                $('#submit-button').toggleClass("loading");
            },
            success: (res) => {
                this.contactForm.trigger('reset');
                $('.success-message').remove();
                $('.error-message').remove();
                $('#submit-button').before(`<span class="success-message">${res.message}</span>`)
            },
            error: (res) => {
                $('.error-message').remove();
                $('.success-message').remove();
                $('#submit-button').before(`<span class="error-message">${res.responseJSON.errors[Object.keys(res.responseJSON.errors)[0]]}</span>`)
            },
            complete: () => {
                $('#submit-button').toggleClass('loading');
                this.processing = false;
            }
        });
    }

    handleForm() {
        this.contactForm.on('submit', (ev) => {
            ev.preventDefault();

            let data = this.contactForm.serializeArray();
            data     = this.serializeForm(data);

            this.sendForm(data);
        });
    }

    maskInput() {
        let SPMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 9 ? '00000-0000' : '0000-00009';
        },
        spOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(SPMaskBehavior.apply({}, arguments), options);
            }
        };

        this.contactForm.find('[name=phone]').mask(SPMaskBehavior, spOptions);
        this.contactForm.find('[name=ddd]').mask('(00)');
    }

    init() {
        if (this.contactForm === null && this.contactForm === undefined) {
            return;
        }

        this.maskInput();
        this.handleForm();
    }
}
